module.exports = __webpack_public_path__ + "img/walletKhazna.ff24d6a6.svg";